import { render, staticRenderFns } from "./ReceivePayment.vue?vue&type=template&id=48389d6a&scoped=true&"
import script from "./ReceivePayment.vue?vue&type=script&lang=js&"
export * from "./ReceivePayment.vue?vue&type=script&lang=js&"
import style0 from "./ReceivePayment.vue?vue&type=style&index=0&id=48389d6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48389d6a",
  null
  
)

export default component.exports